
(function($){
    $(document).ready(function(){

        var ImageBox = Backbone.Model.extend({
            defaults : {
                'id' : null,
                'title' : 'Product Name',
                'credit' : '',
                'url' : null,
                'products' : null
            },
            initialize: function(){
                _.bindAll( this, 'setupCallback', 'setupFromApi' );
                this.setupFromApi();
            },
            setupFromApi: function(){
                let details = {};

                let id = this.get('id');
                if ( typeof id !== 'undefined' && id && !_.isNull( id ) ){
                    details['id'] = id;
                } else {
                    details.url = this.get('url');
                }

                // request here: site_data.api_url_base + 'gr-chair/v1/image-info/'
                $.get( site_data.api_url_base + 'gr-chair/v1/image-info/', details, this.setupCallback );
            },
            setupCallback: function( resp ){
                if ( !_.isEmpty( resp.data ) ) {
                    this.set( resp.data );
                    this.set({ 'fetched' : true });
                }
            }
        });

        var ImageBoxView = Backbone.View.extend({
            events: {
                'click a.info-bug.rendered' : 'openInfoBox'
            },
            initialize: function(){
                _.bindAll( this, 'render', 'openInfoBox', 'closeInfoBox', 'mouseOut', 'mouseOver' );
                this.template = _.template( $('#image-infobox-template').html() );
                this.timeout = false;

                if ( this.model.get( 'fecthed' ) ) {
                    this.render();
                } else {
                    this.listenTo( this.model, 'change:fetched', this.render );
                }
            },
            render: function(){
                this.$('a.info-bug').addClass( 'rendered' );
                let infoBox = this.template( this.model.toJSON());
                this.$el.on( 'mouseenter', this.mouseOver );
                this.$el.on( 'mouseleave', this.mouseOut );
                this.$el.append( infoBox );
                this.openInfoBox();
            },
            closeInfoBox: function(){
                clearTimeout( this.timeout );
                this.$el.removeClass( 'show' );
            },
            openInfoBox: function (){
                this.$el.addClass( 'show' );
            },
            mouseOut: function(){
                this.timeout = setTimeout( this.closeInfoBox, 750 );
            },
            mouseOver: function(){
                if ( this.timeout ) {
                    clearTimeout( this.timeout );
                }
            }
        });
        var imageBoxes = [];
        $( 'body' ).on( 'click', 'a.info-bug', function( e ){
            e.preventDefault();
            if ( $( this ).hasClass( 'rendered' ) ) {
                return;
            }
            var details = {};
            var photoId = $( this ).data( 'photo' );
            if ( typeof photoId !== 'undefined' && photoId ){
                details.id = photoId;
            } 
            
            details.url = $( this ).attr( 'href' );
            var mImage, imageBoxView;
            mImage = new ImageBox( details );
            imageBoxView = new ImageBoxView( { 'el' : $( this ).parent(), 'model' : mImage } );
            // imageBoxView.render();
            imageBoxes.push( imageBoxView );
        });

        $( '.add-info-bug' ).each( function(){
            $( this ).parent().addClass( 'info-bug-wrap' ); 
            // console.log( this.nodeName );
            /* <a href="#" data-photo="<?php echo isset( $photo->id ) ? $photo->id : ''; ?>" class="info-bug" title="Show Photo Details">Show Photo Details</a> */

            var link = document.createElement('a');
            link.classList.add( 'info-bug' );
            link.title = 'Show Photo Details';
            if ( this.nodeName == 'IMG' ) {
                link.href = $( this ).attr( 'src' );
            }
            var linkText = document.createTextNode("Show Photo Details");
            link.appendChild(linkText);
            $( this ).parent().append( link );
        });

        $( '.infobug-row' ).each(function(){
            $( '> .fl-row-content-wrap', this).addClass( 'info-bug-wrap' );
        });
    });
})(jQuery);